import { required, size } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { alphanumeric } from '@/mixins/alphanumeric'
import FiatApis from '@/modules/crypto/services/apis/fiat'
import ProfileApis from '@/services/apis/profile'
import {
  resizeImage, toEnglishDigits, numberWithCommas, toFixed,
} from '@/utils/index'

// const depositCurrency = new FiatApis()
const profile = new ProfileApis()
const fiat = new FiatApis()

export default {
  components:
  {
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      show: false,
      alertShow: false,
      pending: false,
      required,
      size,
      options: [],
      currency: '',
      amount: '',
      file: [],
      bankAccountInfo: null,
      ShowAedBankInfo: false,
      bankAccounts: [],
      depositHistory: [],
      helpers: {
        numberWithCommas,
        toFixed,
      },
    }
  },
  computed: {
    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
    historyFields() {
      return [
        { key: 'created_at', label: this.$t('date') },
        { key: 'amount', label: this.$t('amount') },
        { key: 'currency.name', label: this.$t('currency') },
        { key: 'automation.status', label: this.$t('status') },
      ]
    },
  },
  async created() {
    this.getCurrency()
    await this.getDepositHistory()
  },
  methods: {
    async submit() {
      if (await this.$refs.depositform.validate()) {
        this.pending = true
        const compressedFile = await resizeImage(this.file)
        const data = {
          currency: this.currency.currency,
          amount: toEnglishDigits(this.amount),
          file: compressedFile,
          admin_bank_id: this.bankAccountInfo.id,
        }
        await fiat.saveDeposit(data).then(async () => {
          this.$swal({
            title: this.$t('successful-deposit'),
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          await profile.get()
          this.alertShow = true
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }).finally(() => {
          this.pending = false
        })
      }
    },

    onCurrencyChange() {
      this.ShowAedBankInfo = this.currency.currency === 'AED'
      this.getCurrency()
    },
    async getCurrency() {
      this.show = true
      await fiat.getCurrency().then(async res => {
        this.options = res.data.results
        const [firstCurrency] = res.data.results
        this.currency = firstCurrency
        await fiat.bankAccountInfo({ currency_id: firstCurrency.id, type: 'wire' }).then(bankRes => {
          this.bankAccounts = bankRes.data.results
          const [firstBankAccount] = bankRes.data.results
          this.bankAccountInfo = firstBankAccount
        }).finally(() => {
          this.show = false
        })
        this.ShowAedBankInfo = false
      })``
    },
    async getDepositHistory() {
      // Fetch deposit history from the API
      await fiat.getDeposits().then(response => {
        this.depositHistory = response.data.data
      }).catch(() => {
        this.depositHistory = []
      })
    },
  },
}
